import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import { List, Map, fromJS } from 'immutable';
import { handleActions } from 'redux-actions';
import { combineReducers } from 'redux-immutable';
import { NOT_FETCHING } from "../../constants.js";
import { setPage, setPageData, setUsers, setReportOutcomes, setRollups, setResults, setLoading, setLoadingRemainingPages, clearReportData } from "./actions.js";
var users = handleActions(_defineProperty(_defineProperty({}, setUsers, function (_state, action) {
  return fromJS(action.payload);
}), clearReportData, function (_state, _action) {
  return Map();
}), Map());
var page = handleActions(_defineProperty(_defineProperty({}, setPage, function (state, action) {
  return fromJS(action.payload);
}), clearReportData, function (_state, _action) {
  return fromJS({
    number: void 0
  });
}), fromJS({
  number: void 0
}));
var pageData = handleActions(_defineProperty(_defineProperty({}, setPageData, function (state, action) {
  return fromJS(action.payload);
}), clearReportData, function (_state, _action) {
  return Map();
}), Map());
var outcomes = handleActions(_defineProperty(_defineProperty({}, setReportOutcomes, function (state, action) {
  return fromJS(action.payload);
}), clearReportData, function (_state, _action) {
  return Map();
}), Map());
var rollups = handleActions(_defineProperty(_defineProperty({}, setRollups, function (state, action) {
  return fromJS(action.payload);
}), clearReportData, function (_state, _action) {
  return List();
}), List());
var loading = handleActions(_defineProperty(_defineProperty({}, setLoading, function (state, action) {
  return fromJS(action.payload);
}), clearReportData, function (_state, _action) {
  return false;
}), false);
var loadingRemainingPages = handleActions(_defineProperty(_defineProperty({}, setLoadingRemainingPages, function (state, action) {
  return fromJS(action.payload);
}), clearReportData, function (_state, _action) {
  return NOT_FETCHING;
}), NOT_FETCHING);
var results = handleActions(_defineProperty(_defineProperty({}, setResults, function (state, action) {
  var _action$payload = action.payload,
    outcomeId = _action$payload.outcomeId,
    results = _action$payload.results,
    seenResults = _action$payload.seenResults;
  var resultMap = results.map(function (_ref) {
    var userId = _ref.user_uuid,
      percentScore = _ref.percent_score,
      points = _ref.points,
      pointsPossible = _ref.points_possible,
      attempt = _ref.attempt;
    var ungulated = fromJS({
      userId: userId,
      percentScore: percentScore,
      points: points,
      pointsPossible: pointsPossible,
      attempt: attempt !== null && attempt !== void 0 ? attempt : 1
    });
    return [userId.toString(), ungulated];
  });
  var fetchedResults = Map(resultMap);
  var allResults = Map([].concat(_toConsumableArray(fetchedResults), _toConsumableArray(seenResults)));
  return state.set(outcomeId, allResults);
}), clearReportData, function (_state, _action) {
  return Map();
}), Map());
var openReportAlignmentId = handleActions({
  VIEW_REPORT_ALIGNMENT: function VIEW_REPORT_ALIGNMENT(state, action) {
    return action.payload;
  },
  CLOSE_REPORT_ALIGNMENT: function CLOSE_REPORT_ALIGNMENT() {
    return null;
  }
}, null);
export default combineReducers({
  page: page,
  pageData: pageData,
  users: users,
  outcomes: outcomes,
  results: results,
  rollups: rollups,
  openReportAlignmentId: openReportAlignmentId,
  loading: loading,
  loadingRemainingPages: loadingRemainingPages
});